<template>
  <li
    class="relative py-5 px-4 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 cursor-default"
    :class="[focused ? 'bg-blue-50' : 'bg-white hover:bg-gray-50']"
    @click="$emit('sms-message:focus', smsMessage)"
  >
    <div class="flex justify-between space-x-3">
      <div class="min-w-0 flex-1">
        <p v-if="smsMessage.user" class="text-sm font-medium text-gray-900 truncate">
          {{ smsMessage.user.fullName }}
        </p>
      </div>
      <time
        :datetime="smsMessage.created_at"
        class="flex-shrink-0 whitespace-nowrap text-sm text-gray-500"
        >{{ createdAtFromNow }}</time
      >
    </div>
    <div class="mt-1">
      <p class="line-clamp-2 text-sm text-gray-600">
        {{ smsMessage.content }}
      </p>
    </div>
    <div v-if="canEditOrDelete" class="mt-3 flex space-x-2">
      <BaseButton primary outline small @click.stop="handleSmsMessageEdit"> Edit </BaseButton>
      <BaseButton ghost small @click.stop="handleSmsMessageDelete"> Delete </BaseButton>
    </div>
  </li>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    smsMessage: {
      type: Object,
      required: true,
    },
    focused: Boolean,
  },
  computed: {
    createdAt() {
      return moment.utc(this.smsMessage.created_at).local();
    },
    createdAtShort() {
      return this.createdAt.format('DD-MM-YYYY');
    },
    createdAtFromNow() {
      return this.createdAt.fromNow();
    },
    canEditOrDelete() {
      if (typeof this.smsMessage.tracking_logs_count !== 'number') {
        return false;
      }

      return this.smsMessage.tracking_logs_count === 0;
    },
  },
  methods: {
    handleSmsMessageEdit() {
      if (!this.canEditOrDelete) {
        return;
      }

      this.$emit('sms-message:edit', this.smsMessage);
    },
    handleSmsMessageDelete() {
      if (!this.canEditOrDelete) {
        return;
      }

      this.$emit('sms-message:delete', this.smsMessage);
    },
  },
};
</script>
